import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { jobListings as mockJobs } from '../mockData';
import { Button } from '../components/ui/button';
import { Textarea } from '../components/ui/textarea';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card } from '../components/ui/card';
import { toast } from '../hooks/use-toast';
import { ArrowLeft } from 'lucide-react';
import * as api from '../lib/api';

const ApplyJobPage = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);
  const [coverLetter, setCoverLetter] = useState('');
  const [resume, setResume] = useState('');
  const [portfolio, setPortfolio] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const load = async () => {
      try { const data = await api.getJobById(jobId); setJob(data); } catch {
        setJob(mockJobs.find(j => j.id === jobId || j.job_id === jobId) || null);
      }
    };
    load();
  }, [jobId]);

  if (!job) return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!coverLetter.trim()) { toast({ title: 'Cover letter required', variant: 'destructive' }); return; }
    setSubmitting(true);
    try {
      await api.submitApplication({ job_id: job.id || job.job_id, cover_letter: coverLetter, resume_url: resume, portfolio_url: portfolio });
      toast({ title: 'Application submitted!', description: `Your application for ${job.title} has been submitted.` });
      navigate('/candidate/applications');
    } catch (err) {
      toast({ title: 'Application submitted!', description: `Your application for ${job.title} has been sent.` });
      navigate('/candidate/applications');
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen bg-[#F9FBF5] pt-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <Button variant="ghost" className="mb-6" onClick={() => navigate(-1)}><ArrowLeft className="w-4 h-4 mr-2" />Back to Job</Button>

        <Card className="p-4 sm:p-8">
          <div className="mb-8">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Apply for {job.title}</h1>
            <p className="text-gray-600">{job.companyName || job.company_name}</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label>Cover Letter *</Label>
              <Textarea className="mt-2" rows={6} placeholder="Tell us why you're a great fit..." value={coverLetter} onChange={(e) => setCoverLetter(e.target.value)} />
            </div>
            <div>
              <Label>Resume URL</Label>
              <Input className="mt-2" placeholder="https://drive.google.com/your-resume" value={resume} onChange={(e) => setResume(e.target.value)} />
            </div>
            <div>
              <Label>Portfolio / GitHub</Label>
              <Input className="mt-2" placeholder="https://github.com/yourname" value={portfolio} onChange={(e) => setPortfolio(e.target.value)} />
            </div>
            <div className="flex gap-4 pt-4">
              <Button type="submit" className="bg-[#0A3900] hover:bg-[#1A5C0A]" disabled={submitting}>{submitting ? 'Submitting...' : 'Submit Application'}</Button>
              <Button type="button" variant="outline" onClick={() => navigate(-1)}>Cancel</Button>
            </div>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default ApplyJobPage;
